export const nfseServiceValidationErrorMappings = {
    NFSE_VALIDATION_NFSE_NATIONAL_JSON_INVALID: {
        code: 'NFSE_VALIDATION_NFSE_NATIONAL_JSON_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Falha na validação dos dados da NFS-e Nacional. Verifique as informações e tente novamente.',
            },
            {
                language: 'pt-BR',
                message: 'Falha na validação dos dados da NFS-e Nacional. Verifique as informações e tente novamente.',
            },
            {
                language: 'en-US',
                message: 'National NFS-e data validation failed. Please check the information and try again.',
            },
            {
                language: 'es-ES',
                message: 'Error de validación de datos de NFS-e Nacional. Verifique la información e intente nuevamente.',
            },
        ],
        technicalMessage: 'Falha na validação do JSON de NFSe Nacional',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_NFSE_JSON_INVALID: {
        code: 'NFSE_VALIDATION_NFSE_JSON_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Falha na validação dos dados da NFS-e. Verifique as informações e tente novamente.',
            },
            {
                language: 'pt-BR',
                message: 'Falha na validação dos dados da NFS-e. Verifique as informações e tente novamente.',
            },
            {
                language: 'en-US',
                message: 'NFS-e data validation failed. Please check the information and try again.',
            },
            {
                language: 'es-ES',
                message: 'Error de validación de datos de NFS-e. Verifique la información e intente nuevamente.',
            },
        ],
        technicalMessage: 'Falha na validação do JSON de NFSe',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_SERVICE_CODE_DIGITS_REQUIRED: {
        code: 'NFSE_VALIDATION_SERVICE_CODE_DIGITS_REQUIRED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O código de serviço deve conter exatamente 6 dígitos. Verifique o código informado.',
            },
            {
                language: 'pt-BR',
                message: 'O código de serviço deve conter exatamente 6 dígitos. Verifique o código informado.',
            },
            {
                language: 'en-US',
                message: 'The service code must contain exactly 6 digits. Please check the provided code.',
            },
            {
                language: 'es-ES',
                message: 'El código de servicio debe contener exactamente 6 dígitos. Verifique el código informado.',
            },
        ],
        technicalMessage: 'O campo deve conter exatamente 6 dígitos numéricos',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_TAX_CODE_DIGITS_REQUIRED: {
        code: 'NFSE_VALIDATION_TAX_CODE_DIGITS_REQUIRED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O código de tributação deve conter exatamente 3 dígitos. Verifique o código informado.',
            },
            {
                language: 'pt-BR',
                message: 'O código de tributação deve conter exatamente 3 dígitos. Verifique o código informado.',
            },
            {
                language: 'en-US',
                message: 'The tax code must contain exactly 3 digits. Please check the provided code.',
            },
            {
                language: 'es-ES',
                message: 'El código de tributación debe contener exactamente 3 dígitos. Verifique el código informado.',
            },
        ],
        technicalMessage: 'O campo deve conter exatamente 3 dígitos numéricos',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_SERVICE_CODE_INVALID_LC116: {
        code: 'NFSE_VALIDATION_SERVICE_CODE_INVALID_LC116',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O código de serviço informado não é válido. Consulte a Lista de Serviços da Lei Complementar 116 (LC 116) ou verifique o código correto no portal da prefeitura do município.',
            },
            {
                language: 'pt-BR',
                message: 'O código de serviço informado não é válido. Consulte a Lista de Serviços da Lei Complementar 116 (LC 116) ou verifique o código correto no portal da prefeitura do município.',
            },
            {
                language: 'en-US',
                message: 'The provided service code is not valid. Consult the LC 116 Service List or check the correct code on the city hall portal.',
            },
            {
                language: 'es-ES',
                message: 'El código de servicio informado no es válido. Consulte la Lista de Servicios de la LC 116 o verifique el código correcto en el portal de la alcaldía.',
            },
        ],
        technicalMessage: 'consulte a LC 116 ou verifique no portal da prefeitura',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_SERVICE_CODE_REQUIRED: {
        code: 'NFSE_VALIDATION_SERVICE_CODE_REQUIRED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O código de serviço é obrigatório. Preencha o campo antes de emitir a nota.',
            },
            {
                language: 'pt-BR',
                message: 'O código de serviço é obrigatório. Preencha o campo antes de emitir a nota.',
            },
            {
                language: 'en-US',
                message: 'The service code is required. Please fill in the field before issuing the invoice.',
            },
            {
                language: 'es-ES',
                message: 'El código de servicio es obligatorio. Complete el campo antes de emitir la factura.',
            },
        ],
        technicalMessage: 'codigo: Preenchimento obrigatório',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_SERVICE_CODE_MIN_6_DIGITS: {
        code: 'NFSE_VALIDATION_SERVICE_CODE_MIN_6_DIGITS',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O código de serviço precisa ter no mínimo 6 dígitos. Verifique o valor informado.',
            },
            {
                language: 'pt-BR',
                message: 'O código de serviço precisa ter no mínimo 6 dígitos. Verifique o valor informado.',
            },
            {
                language: 'en-US',
                message: 'The service code must have at least 6 digits. Please check the provided value.',
            },
            {
                language: 'es-ES',
                message: 'El código de servicio debe tener al menos 6 dígitos. Verifique el valor informado.',
            },
        ],
        technicalMessage: 'codigo: Tamanho mínimo (sem máscara): 6',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_TAX_CODE_MIN_3_DIGITS: {
        code: 'NFSE_VALIDATION_TAX_CODE_MIN_3_DIGITS',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O código de tributação precisa ter no mínimo 3 dígitos. Verifique o valor informado.',
            },
            {
                language: 'pt-BR',
                message: 'O código de tributação precisa ter no mínimo 3 dígitos. Verifique o valor informado.',
            },
            {
                language: 'en-US',
                message: 'The tax code must have at least 3 digits. Please check the provided value.',
            },
            {
                language: 'es-ES',
                message: 'El código de tributación debe tener al menos 3 dígitos. Verifique el valor informado.',
            },
        ],
        technicalMessage: 'codigoTributacao: Tamanho mínimo (sem máscara): 3',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_COMPLEMENTARY_INFO_FORMAT: {
        code: 'NFSE_VALIDATION_COMPLEMENTARY_INFO_FORMAT',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Formato das informações complementares inválido. Para quebra de linha, utilize o caractere | (Pipe).',
            },
            {
                language: 'pt-BR',
                message: 'Formato das informações complementares inválido. Para quebra de linha, utilize o caractere | (Pipe).',
            },
            {
                language: 'en-US',
                message: 'Invalid complementary information format. For line breaks, use the | (Pipe) character.',
            },
            {
                language: 'es-ES',
                message: 'Formato de información complementaria inválido. Para salto de línea, use el carácter | (Pipe).',
            },
        ],
        technicalMessage: 'Para quebra de linha, utilize o',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_RPS_NUMBER_REQUIRED_MANUAL: {
        code: 'NFSE_VALIDATION_RPS_NUMBER_REQUIRED_MANUAL',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O número do RPS é obrigatório quando a numeração automática está desativada. Ative a numeração automática ou informe o número manualmente nas configurações.',
            },
            {
                language: 'pt-BR',
                message: 'O número do RPS é obrigatório quando a numeração automática está desativada. Ative a numeração automática ou informe o número manualmente nas configurações.',
            },
            {
                language: 'en-US',
                message: 'RPS number is required when automatic numbering is disabled. Enable automatic numbering or provide the number manually in settings.',
            },
            {
                language: 'es-ES',
                message: 'El número de RPS es obligatorio cuando la numeración automática está desactivada. Active la numeración automática o proporcione el número manualmente en la configuración.',
            },
        ],
        technicalMessage: 'Campo obrigatório quando a numeração automática estiver desativada',
        severity: 'error',
        critical: false,
    },
};
